import { ButtonBase, Icon } from '@material-ui/core'
import React, { FC, memo, useState } from 'react'
import styles from './PaymentCardItem.module.scss'
import clsx from "clsx";

interface PaymentCardItemProps {
    textTop?: string
    textBottom?: string
    iconName?: string
    imageSrc?: any
    imageSize?: {
        width: number
        height: number
    }
    onClick?: () => void
    disabled?: boolean
    selected?: boolean
}

export const PaymentCardItem: FC<PaymentCardItemProps> = memo((
    { imageSize, onClick, textTop, textBottom, imageSrc, iconName, disabled, selected }
) => {
    return (
        <>
            <ButtonBase
                onClick={onClick}
                disabled={disabled}
                className={clsx(
                    styles.containerCardItem,
                    disabled && styles.disabled,
                    selected && styles.selected
                )}>
                {
                    iconName &&
                    <div className={styles.iconGridCardItem}>
                        <Icon className={"icon-card-item"}>{iconName}</Icon>
                    </div>
                }
                {
                    imageSrc &&
                    <div className={styles.brandImageContentCardItem}>
                        <img alt="Payment Icon"
                             style={{
                                 width: imageSize?.width ?? 50,
                                 height: imageSize?.height ?? 50,
                                 objectFit: "contain"
                             }}
                             src={imageSrc}>
                        </img>
                    </div>
                }
                <div className={styles.contentCardItem}>
                    <div className={styles.textContentCardItem}>
                        <div className={styles.topContentCardItem}>
                            {textTop}
                        </div>
                        <div className={styles.bottomContentCardItem} >
                            {textBottom}
                        </div>
                    </div>
                </div>
            </ButtonBase>
        </>
    )
})
